/*!
 * Copyright 2026 - Swiss Data Science Center (SDSC)
 * A partnership between École Polytechnique Fédérale de Lausanne (EPFL) and
 * Eidgenössische Technische Hochschule Zürich (ETHZ).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License
 */

/**
 * If the given URL is a known data repository URL, extract and return the DOI.
 * Otherwise, return the input unchanged.
 */
export function doiFromUrl(url: string): string {
  const zenodoUrl = /zenodo\.org\/records\/(\d+)/;
  const dataverseUrl = /\?persistentId=doi:(.+)/;

  if (zenodoUrl.test(url)) {
    const parts = url.split("/");
    return `10.5281/zenodo.${parts[parts.length - 1]}`;
  }

  if (dataverseUrl.test(url)) {
    const parts = url.split("doi:");
    const lastPart = parts[parts.length - 1];
    const doiPart = lastPart.split("&")[0];
    return doiPart;
  }

  return url;
}
